import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { throwError } from "rxjs";
import { Configuration } from "../configuration";
import { IApplicant } from "../model/IApplicant";
import { CookieService } from "ngx-cookie-service";
import { CookiesLocalService } from "./cookies-local.service";

export class ServiceBase {
  public isOffLineMode = true;

  public currentApplicantData: IApplicant;
  public http: HttpClient;
  public baseUrl = Configuration.apiData.serverUrl;
  errorData: {};
  constructor(
    private baseHttp: HttpClient,
    public cookieService: CookieService,
    public cookieLocal: CookiesLocalService
  ) {
    this.http = baseHttp;

    const applicantData = this.cookieLocal.getApplicantData();
    if (applicantData) {
      this.currentApplicantData = applicantData;
    }
  }

  public errorHandler(error: HttpErrorResponse) {
    if (error.status === 401 || error.status === 403) {
      console.log("Error_Token_Expired: redirecting to login.");
      // this.router.navigate(['account/login']);
    }
    if (error.error instanceof ErrorEvent) {
      console.error("An error occurred:", error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    this.errorData = {
      errorTitle: "Oops! Request for document failed",
      errorDesc: "Something bad happened. Please try again later.",
      code: error.status,
      body: error.error,
    };
    return throwError(this.errorData);
  }

  public getHttpHeaderOptionWithToken() {
    // console.log(this.cookieLocal.getUserToken());
    return {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.cookieLocal.getUserToken(),
      }),
    };
  }

  public getHttpHeaderOptionWithTokenForMimeType() {
    return {
      headers: new HttpHeaders({
        // 'processData':  'false',
        Accept: "application/json",
        Authorization: "Bearer " + this.cookieLocal.getUserToken(),
      }),
    };
  }

  public getHttpHeaderOptionWithNoAuth() {
    return {
      headers: new HttpHeaders({
        "Content-Type": "application/x-www-form-urlencoded",
        "No-Auth": "True",
      }),
    };
  }
  public getHttpHeaderOptionWithNoAuthWithJson() {
    return { headers: new HttpHeaders({ "Content-Type": "application/json" }) };
  }
}
